import { useState } from 'react'

import { generateFixedItemLink, generateItemLink } from './auctionsadminutil'

import themeCss from '../components/sass/theme.module.scss'
import css from './sass/adminitem.module.scss'

export default function ItemListGenerateButton({ auction}) {
  const [copied, setCopied] = useState(false)

  const sanitizeForClipboard = (value) => {
    if (!value) return ''

    return value
      .replace(/\r?\n|\r/g, ' ')
      .replace(/\t/g, ' ')
  }

  const createTableSection = (headers, rows) => {
    if (!rows.length) return []

    return [
      headers.join('\t'),
      ...rows.map((row) => row.join('\t')),
    ]
  }

  const performCopy = async () => {
    const auctionCode = auction?.AuctionCode
    const items = auction?.Items || []
    const fixedItems = auction?.FixedItems || []
    const sections = []

    if (items.length > 0) {
      const itemRows = items.map((item) => [
        sanitizeForClipboard(item?.Title),
        generateItemLink(item?.ItemCode, auctionCode),
      ])

      sections.push(createTableSection(['Item Title', 'Item Link'], itemRows))
    }

    if (fixedItems.length > 0) {
      const fixedItemRows = fixedItems.map((item) => [
        sanitizeForClipboard(item?.Title),
        generateFixedItemLink(item?.ItemCode, auctionCode),
      ])

      sections.push(createTableSection(['Fixed Item Title', 'Fixed Item Link'], fixedItemRows))
    }

    if (sections.length === 0) return

    await navigator.clipboard.writeText(sections.map((section) => section.join('\n')).join('\n\n'))
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 1000)
  }

  // if (isUserSR) return <></>
  if (auction.Items.length === 0 && auction.FixedItems.length === 0) return <></>

  return (
    <div className={css['copy-link-button-container']}>
      {copied && <p className={css['copied-alert']}>Copied to clipboard.</p>}
      <button type='button' className={`${themeCss['FilledYellow']} ${themeCss['button']}`} onClick={()=>performCopy()}>
        Copy All Item URLs
      </button>
    </div>
  )
}
